export default __webpack_public_path__ + "static/media/no-picture-room.7f32f6f3.png";